import { useSelector } from 'react-redux';
import { colors } from '../../../../colors';
import { OverviewChartTimeframe } from '../../types';
import {
  selectOverviewChartTimeframe,
  setOverviewChartTimeframe,
} from '../../../../store/slices/ui';
import './index.css';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

const OverviewChartTimeframeSelector = () => {
  const overviewChartTimeframe = useSelector(selectOverviewChartTimeframe);
  const dispatch = useDispatch();

  const handleClick = useCallback(
    (timeframe: OverviewChartTimeframe) => {
      dispatch(setOverviewChartTimeframe(timeframe));
    },
    [dispatch],
  );

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        overflowX: 'scroll',
        maxWidth: '100vw',
        justifyContent: 'center',
        rowGap: 12,
      }}
    >
      {Object.values(OverviewChartTimeframe).map((timeFrame) => (
        <div
          key={timeFrame}
          className="overview-chart-timeframe"
          style={{
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 2,
            paddingBottom: 2,
            backgroundColor:
              timeFrame === overviewChartTimeframe ? colors.white : '#181818',
            color:
              timeFrame === overviewChartTimeframe
                ? colors.black
                : 'rgb(110, 110, 110)',
            cursor: 'pointer',
            fontWeight: 'bold',
            marginLeft: 8,
            marginRight: 8,
            borderRadius: 12,
            fontSize: 14,
          }}
          onClick={() => handleClick(timeFrame)}
        >
          {timeFrame}
        </div>
      ))}
    </div>
  );
};

export default OverviewChartTimeframeSelector;
